import React from "react";
import {
  Typography,
  Button,
  Card,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Modal,
  TextField,
  Box,
  TableFooter,
  Divider,
  Paper,
  Avatar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  InputAdornment,
  Stack,
  Fade,
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";

//Import One Line Snippet:
//import { PrimaryButton, CancelButton, SecondaryButton } from 'src/components/Buttons/ModalButtons';

// Styled Primary Button Used For Adding/Editing/Deleting Users, Locations, Customers & Whatever Else
const AddButton = ({ onClick, text, icon, disabledState }) => {
  return (
    <Paper
      elevation={4}
      sx={{
        borderRadius: "9px",
        marginRight: 0.25,
        height: "34px",
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: "#f2f7f9",
          opacity: 0.9,
          boxShadow: (theme) => theme.shadows[2], // Increase elevation on hover
        },
      }}
    >
      <IconButton
        variant="contained"
        onClick={onClick}
        disabled={disabledState}
        sx={{
          minWidth: 85,
          height: "34px",
          borderRadius: "9px",
          backgroundColor: "#FFFFFF",
          border: "1.25px solid #c2d7df",
          padding: 1,
          "&:hover": {
            backgroundColor: "#e9f1f5",
          },
        }}
      >
        <Box
          sx={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.25,
          }}
        >
          <AddRoundedIcon
            sx={{
              mt: "1px",
              width: "20px", // Adjusted to fit inside the box with padding
              height: "20px",
              color: "#48768C",
            }}
          />{" "}
          <Typography
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 13.5,
              fontWeight: 600,
              color: "#48768C",
              whiteSpace: "nowrap",
              letterSpacing: "-.005em",
              mx: "2px",
            }}
          >
            {text}
          </Typography>
        </Box>
      </IconButton>
    </Paper>
  );
};


const AddNotificationButton = ({ onClick, text, icon, disabledState }) => {
  return (
    <Paper
      elevation={1}
      sx={{
        borderRadius: "9px",
        marginRight: 0.25,
 
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: "#f2f7f9",
          opacity: 0.9,
          boxShadow: (theme) => theme.shadows[2], // Increase elevation on hover
        },
      }}
    >
      <IconButton
        variant="contained"
        onClick={onClick}
        disabled={disabledState}
        sx={{
          minWidth: 85,
          height: "34px",
          borderRadius: "6px",
          backgroundColor: "#fbfefe",
          border: ".5px solid #97bac9",
          px:'20px',
          py:'18px',

          "&:hover": {
            backgroundColor: "#e9f1f5",
          },
        }}
      >
        <Box
          sx={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.25,
          }}
        >
          <AddRoundedIcon
            sx={{
              mt: "1px",
              width: "20px", // Adjusted to fit inside the box with padding
              height: "20px",
              color: "#48768C",
              mr:.5
            }}
          />{" "}
          <Typography
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 15,
              fontWeight: 600,
              color: "#48768C",
              whiteSpace: "nowrap",
              letterSpacing: -.01,
              mx: "2px",
            }}
          >
            {text}
          </Typography>
        </Box>
      </IconButton>
    </Paper>
  );
};


const EditButton = ({ onClick, text, icon }) => {
  return (
    <Paper
      elevation={4}
      sx={{
        mt: "1px",
        borderRadius: "9px",
        marginRight: 0.25,
        "&:hover": {
          backgroundColor: "#f2f7f9",
          opacity: 0.9,
          boxShadow: (theme) => theme.shadows[2], // Increase elevation on hover
        },
      }}
    >
      <IconButton
        variant="contained"
        onClick={onClick}
        sx={{
          minWidth: 85,
          height: "34px",
          borderRadius: "9px",
          backgroundColor: "#FFFFFF",
          border: "2px solid #c2d7df",
          padding: 1,
          "&:hover": {
            backgroundColor: "#e9f1f5",
          },
        }}
      >
        <Box
          sx={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.25,
          }}
        >
          <AddRoundedIcon
            sx={{
              mt: "1px",
              width: "20px", // Adjusted to fit inside the box with padding
              height: "20px",
              color: "#48768C",
            }}
          />{" "}
          <Typography
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 13.5,
              fontWeight: 600,
              color: "#48768C",
              whiteSpace: "nowrap",
              letterSpacing: "-.01em",
              mx: "3px",
            }}
          >
            {text}
          </Typography>
        </Box>
      </IconButton>
    </Paper>
  );
};

const DeleteButton = ({ onClick, text, icon }) => {
  return (
    <Paper
      elevation={4}
      sx={{
        mt: "1px",
        borderRadius: "9px",
        marginRight: 0.25,
        "&:hover": {
          backgroundColor: "#f2f7f9",
          opacity: 0.9,
          boxShadow: (theme) => theme.shadows[2], // Increase elevation on hover
        },
      }}
    >
      <IconButton
        variant="contained"
        onClick={onClick}
        sx={{
          minWidth: 85,
          height: "34px",
          borderRadius: "9px",
          backgroundColor: "#FFFFFF",
          border: "2px solid #c2d7df",
          padding: 1,
          "&:hover": {
            backgroundColor: "#e9f1f5",
          },
        }}
      >
        <Box
          sx={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.25,
          }}
        >
          <AddRoundedIcon
            sx={{
              mt: "1px",
              width: "20px", // Adjusted to fit inside the box with padding
              height: "20px",
              color: "#48768C",
            }}
          />{" "}
          <Typography
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 13.5,
              fontWeight: 600,
              color: "#48768C",
              whiteSpace: "nowrap",
              letterSpacing: "-.01em",
              mx: "3px",
            }}
          >
            {text}
          </Typography>
        </Box>
      </IconButton>
    </Paper>
  );
};

// Usage in a Component
function AddDeleteEditButtons() {
  return (
    <div>
      <AddButton />
      <AddNotificationButton />
      <EditButton />
      <DeleteButton />
    </div>
  );
}

export { AddButton, AddNotificationButton, EditButton, DeleteButton };
export default AddDeleteEditButtons;
